import { render, staticRenderFns } from "./AgeModal.vue?vue&type=template&id=1da30a20"
import script from "./AgeModal.vue?vue&type=script&lang=js"
export * from "./AgeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports